<template>
	<b-container fluid>
		<div class="form-wrapper">
			<b-form @submit.prevent="createEnquiry">
				<b-form-fieldset>
					<legend>Customer Enquiry</legend>

					<b-form-group>
						<vue-typeahead-bootstrap
							class="mb-4"
							v-model="query"
							:data="searchCustomers"
							:serializer="item => item.Title"
							@hit="customer = $event"
							placeholder="Search existing"
							showOnFocus	
						/>
						<b-button @click.prevent="clearEnquiry">New Customer</b-button>
					</b-form-group>

					<b-form-group label="Customer:" for="title">
						<b-input id="title" v-model="customer.Title" maxlength="60" required />
					</b-form-group>

					<b-form-group label="Description:" for="description">
						<b-textarea id="description" v-model="customer.Description" type="text" required />
					</b-form-group>
				</b-form-fieldset>

				<b-form-fieldset>
					<legend>Contacts</legend>

					<b-button v-b-modal.addModal>Add contact</b-button>

					<div class="table-responsive">
						<table class="table table-striped">
							<thead>
								<tr>
									<th>Title</th>
                                    <th>Name</th>									
									<th>Role</th>
									<th>Remove</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(contact, index) in customer.Contacts" :key="contact.Id">
									<td>{{ contact.Title }}</td>
									<td>{{ contact.Name }}</td>								
									<td>
										<b-form-select id="contact_duty" v-model="contact.DutyId" :options="contactDuties" required></b-form-select>
									</td>
									<td>
										<b-button
											variant="danger"
											@click.prevent="removeFromArray(customer.Contacts, index)"
										>&times;</b-button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</b-form-fieldset>

				<b-form-fieldset>
					<legend>Job</legend>

					<b-form-group label="Clock:" for="clock">
						<b-input id="title" v-model="clock.Name" maxlength="60" />
					</b-form-group>

					<b-form-group label="Name:" for="title">
						<b-input id="title" v-model="job.Title" maxlength="60" />
					</b-form-group>

					<b-form-group label="Description:" for="description">
						<b-textarea id="description" v-model="job.Description" type="text" />
					</b-form-group>

					<legend>Tasks</legend>

					<b-button v-b-modal.addModal>Add task</b-button>

					<div class="table-responsive">
						<table class="table table-striped">
							<thead>
								<tr>
									<th>Name</th>
									<th>Scheduled</th>
									<th>Remove</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(assignment, index) in job.Assignments" :key="assignment.Id">
									<td>{{ assignment.Title }}</td>
									<td>{{ assignment.Scheduled }}</td>
									<td>
										<b-button
											variant="danger"
											@click.prevent="removeFromArray(job.Assignments, index)"
										>&times;</b-button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</b-form-fieldset>

				<b-button type="submit" variant="info">Save</b-button>

				<b-button :to="{ name: 'home' }" variant="danger">Cancel</b-button>
			</b-form>
		</div>

		<b-modal id="addModal" ref="modal" title="Add" hide-footer>
			<add-contact-to-parent @addContact="addContact" :contactDuties="contactDuties" />
		</b-modal>

		<b-modal ref="alertModal" :title="alertModalTitle" :ok-only="true" @ok="onAlertModalOkClick">
			<p class="my-4">{{ alertModalContent }}</p>
		</b-modal>
	</b-container>
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import CustomerService from "@/api-services/customer.service";
import AddContactToParent from "@/components/partials/add-contact-to-parent";

export default {
	name: "EnquiryCreate",

	components: {
		VueTypeaheadBootstrap,
		AddContactToParent
	},

	data() {
		return {
			// Database models
			customer: {
				Id: null,
				Title: "",
				Description: "",
				Contacts: [],
				Jobs: []
			},

			clock: {
				Id: null,
				Name: ""
			},

			job: {
				Title: "",
				Clock: "",
				Assignments: []
			},

			contactDuties: [
				{ value: null, text: "Please select an option" },
				{ value: "1", text: "Primary Contact" },
				{ value: "2", text: "Key holder" },
				{ value: "3", text: "Emergency" },
                { value: "4", text: "Secondary" },
                { value: "5", text: "Invoice" },
                { value: "6", text: "Owner" }
			],

			// Just for the automplete, query holds the typed query and the array holds all returned results
			query: "",
			searchCustomers: [],

			// Alert modal settings
			alertModalTitle: "",
			alertModalContent: "",
			isSuccess: false
		};
	},

	methods: {
		clearEnquiry() {
			this.customer = {
				Id: null,
				Title: "",
				Description: "",
				Contacts: [],
				Jobs: []
			};
		},

		addContact(contactFromForm) {
			this.customer.Contacts.push(contactFromForm);
			// Hide the modal manually
			this.$nextTick(() => {
				this.$refs.modal.hide();
			});
		},

		removeFromArray: function(arr, index) {
			this.$delete(arr, index);
		},

		createEnquiry() {			
            // dont send Id attribute for new customers
            if (this.customer.Id == null) delete this.customer.Id;

			CustomerService.create(this.customer)
				.then(() => {
					this.isSuccess = true;
					this.alertModalTitle = "Success";
					this.alertModalContent = "Successfully created Customer";
					this.$refs.alertModal.show();

					this.customer = {};
				})
				.catch(error => {
					this.isSuccess = false;
					this.alertModalTitle = "Error";
					this.alertModalContent = error.response.data;
					this.$refs.alertModal.show();
				});
		},

		onAlertModalOkClick() {
			if (this.isSuccess) {
				this.$router.push({ name: "customers" });
			}
		},

		setCustomer(customer) {
			this.customer = customer;
			// access the autocomplete component methods from the parent
			this.$refs.autocomplete.clear();
		}
	},

	watch: {
		// When the query value changes, fetch new results from the API
		query(newQuery) {
			CustomerService.search(newQuery).then(res => {
				this.searchCustomers = res.data;
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/enquiry/enquiry-create.vue